
define('text!libs/strand/src/strand-collection/example.html',[],function () { return '<template is="dom-bind">\n\t<strand-collection id="searchResults" data="{{dataList}}" auto="false">\n\t</strand-collection>\n\t<template is="dom-repeat" items="{{datalist}}">\n\t\t<div>{{item.name}}</div>\n\t</template>\n</template>';});

